"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSuggestionsVisibilityLimit = exports.setQuestionCloudCategories = exports.setAutoReplyCategories = exports.savePricingEngineCategories = exports.isAutoReplyFeatureVisibleInbox = exports.isAutoReplyFeatureVisible = exports.isAutoReplyFeatureInboxCardViewed = exports.isAutoReplyFeatureEnabled = exports.isAutoReplyEnabledInCurrentSession = exports.getPricingEngineCategories = exports.getAutoReplyCategories = exports.autoReplyInboxCardViewed = void 0;
var _localStorage = require("./localStorage");
var _constants = require("../Constants/constants");
/* global window */

var getAutoReplyCategories = exports.getAutoReplyCategories = function getAutoReplyCategories() {
  if ((0, _localStorage.supportLocalStorage)()) {
    var autoReplyCategories = window.localStorage.getItem(_constants.AUTO_REPLY_CATEGORIES);
    return autoReplyCategories || [];
  }
  return [];
};
var savePricingEngineCategories = exports.savePricingEngineCategories = function savePricingEngineCategories(flag, data) {
  if (flag) {
    if (data[_constants.PRICE_ENGINE_CATEGORIES].length) {
      if ((0, _localStorage.supportLocalStorage)()) {
        window.localStorage.setItem(_constants.PRICE_ENGINE_CATEGORIES, data[_constants.PRICE_ENGINE_CATEGORIES]);
      }
    }
  }
};
var getPricingEngineCategories = exports.getPricingEngineCategories = function getPricingEngineCategories() {
  if ((0, _localStorage.supportLocalStorage)()) {
    var pricingEngineCategories = window.localStorage.getItem(_constants.PRICE_ENGINE_CATEGORIES);
    return pricingEngineCategories || [];
  }
  return [];
};
var isAutoReplyFeatureVisibleInbox = exports.isAutoReplyFeatureVisibleInbox = function isAutoReplyFeatureVisibleInbox() {
  return getAutoReplyCategories().length;
};
var isAutoReplyFeatureVisible = exports.isAutoReplyFeatureVisible = function isAutoReplyFeatureVisible(catId) {
  return getAutoReplyCategories().includes(catId) && isAutoReplyFeatureVisibleInbox();
};
var isAutoReplyFeatureEnabled = exports.isAutoReplyFeatureEnabled = function isAutoReplyFeatureEnabled() {
  var autoReplyUserPreference = false;
  if ((0, _localStorage.supportLocalStorage)()) {
    autoReplyUserPreference = window.localStorage.getItem(_constants.AUTO_REPLY);
    return autoReplyUserPreference && JSON.parse(autoReplyUserPreference);
  }
  return false;
};
var setQuestionCloudCategories = exports.setQuestionCloudCategories = function setQuestionCloudCategories(flag, data) {
  if (flag) {
    if (data.question_cloud_categories.length) {
      if ((0, _localStorage.supportLocalStorage)()) {
        window.localStorage.setItem(_constants.QUESTIONS_CLOUD_CATEGORIES, data.question_cloud_categories);
      }
    }
  }
};
var setSuggestionsVisibilityLimit = exports.setSuggestionsVisibilityLimit = function setSuggestionsVisibilityLimit(data) {
  if (data) {
    if ((0, _localStorage.supportLocalStorage)()) {
      window.localStorage.setItem(_constants.SUGGESTIONS_VISIBILE_LIMIT, data);
    }
  }
};
var setAutoReplyCategories = exports.setAutoReplyCategories = function setAutoReplyCategories(flag, data) {
  if (flag) {
    if (data.auto_reply_categories.length) {
      if ((0, _localStorage.supportLocalStorage)()) {
        window.localStorage.setItem(_constants.AUTO_REPLY_CATEGORIES, data.auto_reply_categories);
      }
    }
  }
};
var isAutoReplyFeatureInboxCardViewed = exports.isAutoReplyFeatureInboxCardViewed = function isAutoReplyFeatureInboxCardViewed() {
  if ((0, _localStorage.supportLocalStorage)()) {
    var isAutoReplyCardViewed = window.localStorage.getItem(_constants.INBOX_AUTO_REPLY_CARD_VIEWED);
    return isAutoReplyCardViewed ? JSON.parse(isAutoReplyCardViewed) : false;
  }
  return false;
};
var isAutoReplyEnabledInCurrentSession = exports.isAutoReplyEnabledInCurrentSession = function isAutoReplyEnabledInCurrentSession() {
  var autoReplyUserPreference = false;
  if ((0, _localStorage.supportLocalStorage)()) {
    autoReplyUserPreference = window.localStorage.getItem(_constants.AUTO_REPLY_VISIBLE_IN_CURRENT_SESSION);
    return autoReplyUserPreference && JSON.parse(autoReplyUserPreference);
  }
  return false;
};
var autoReplyInboxCardViewed = exports.autoReplyInboxCardViewed = function autoReplyInboxCardViewed() {
  if ((0, _localStorage.supportLocalStorage)()) {
    window.localStorage.setItem(_constants.INBOX_AUTO_REPLY_CARD_VIEWED, true);
  }
};